<template>
<div class="in_clazz_panel after_border" @click="gotoClazzCycle">
  <img class="cover" v-lazy="clazz.cover_url">
  <div class="info">
    <div class="title">{{ clazz.clazz_name }}</div>
    <div class="cycle">时间：
      {{ clazz.start_time_format2 }}
      ～
      {{ clazz.end_time_format2 }}
    </div>
    <div class="process">进度：{{ clazz.past_day_num }}/{{ clazz.day_num }}</div>

    <van-progress
        color="#f5222d"
        :show-pivot="false"
        :percentage="percentage"
    />

    <!-- <div v-if="clazz.in_range" class="btn_daka_warp">
      <div class="btn_daka" @click.stop="gotoDaka">打卡</div>
    </div> -->
  </div>
</div>
</template>

<script>
import { Progress } from 'vant'
export default {
  name: 'InClazzPanel',
  components: {
    [Progress.name]: Progress
  },
  props: {
    clazz: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    percentage () {
      return 100 * this.clazz.past_day_num / this.clazz.day_num
    }
  },
  created () {
  },
  methods: {
    gotoClazzCycle () {
      this.$router.push('/join/clazz/' + this.clazz.uuid)
    },
    gotoDaka () {
      this.$router.push(`/daka?clazz_id=${this.clazz.uuid}`)
    }
  }
}
</script>

<style scoped lang="scss">
.in_clazz_panel {
  width: 750px;
  height: 180px;
  padding: 25px 0;
  display: flex;
  .cover {
    width: 180px;
    height: 180px;
    margin-left: 20px;
    object-fit: cover;
  }
  .info {
    display: flex;
    flex-direction: column;
    height: 180px;
    margin-left: 20px;
    width: 500px;
    .title {
      font-size: 26px;
      font-weight: bold;
      color: #323233;
      height: 40px;
    }
    .cycle, .process {
      font-size: 22px;
      color: #bbb;
      height: 40px;
    }
    .process {
      height: 33px;
    }
    .btn_daka_warp {
      display: flex;
      justify-content: flex-end;
    }
    .btn_daka {
      width: 100px;
      height: 45px;
      color: #fff;
      background-color: #f5222d;
      font-size: 24px;
      margin-top: 8px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
